import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, toDisplayString } from 'vue';

const _hoisted_1 = { class: "price-element__main" };
const _hoisted_2 = {
  key: 0,
  class: "price-element__discount"
};
const _hoisted_3 = { class: "price-element__previous" };
const _hoisted_4 = { class: "price-element__discount-percentage" };
const _hoisted_5 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PriceElement",
  props: {
    currentPrice: {},
    previousPrice: { default: "" },
    discount: { default: "" },
    isHighlighted: { type: Boolean, default: false },
    alignment: { default: "left" },
    subline: { default: "" }
  },
  setup(__props) {
    const props = __props;
    const hasDiscount = computed(() => {
      return props.previousPrice && props.discount;
    });
    const alignmentClass = computed(() => {
      return `price-element--align-${props.alignment}`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["price-element", alignmentClass.value])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", {
            class: normalizeClass(["price-element__current", { "price-element__current--highlighted": _ctx.isHighlighted }])
          }, toDisplayString(_ctx.currentPrice), 3),
          hasDiscount.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
            createElementVNode("span", _hoisted_3, toDisplayString(_ctx.previousPrice), 1),
            createElementVNode("span", _hoisted_4, toDisplayString(_ctx.discount), 1)
          ])) : createCommentVNode("", true)
        ]),
        _ctx.subline ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "price-element__subline",
          innerHTML: _ctx.subline
        }, null, 8, _hoisted_5)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
